export const PC24_CREDIT_IMPORT_FAILURE_REASONS = {
    AUTH_ERROR: 'auth_error',
    DATA_ERROR: 'data_error',
    DATA_FORMAT_ERROR: 'data_format_error',
    DATASET_EXPIRED: 'dataset_expired',
    MISSING_REQUIRED_FIELD: 'missing_required_field',
    NETWORK_ERROR: 'network_error',
    RETRIES_EXHAUSTED: 'retries_exhausted',
    SERVER_ERROR: 'server_error',
} as const;

export const PC24_CREDIT_IMPORT_STATUSES = {
    FAILED: 'failed',
    IDLE: 'idle',
    IN_FLIGHT: 'in-flight',
    SUCCEEDED: 'succeeded',
} as const;

// Stable discriminators for 409 ConflictError messages. The backend prefixes
// the message with `<code>: ...`; the frontend matches the prefix instead of
// free-form English so wording changes can't silently break UX branching.
export const PC24_CREDIT_IMPORT_CONFLICT_CODES = {
    ALREADY_IN_FLIGHT: 'PC24_ALREADY_IN_FLIGHT',
    CENSORED_LEAD: 'PC24_CENSORED_LEAD',
    INTEGRATION_DISABLED: 'PC24_INTEGRATION_DISABLED',
    MISSING_PROCHECK_ID: 'PC24_MISSING_PROCHECK_ID',
    NO_DATA_PROTECTION_CONSENT: 'PC24_NO_DATA_PROTECTION_CONSENT',
    NO_DATASET_TO_REGENERATE: 'PC24_NO_DATASET_TO_REGENERATE',
} as const;

// How long a stored PC24 entry link stays directly openable before the open control
// transparently regenerates it. Shared: the frontend computes staleness from this value.
export const PC24_ENTRY_LINK_TTL_MS = 48 * 60 * 60 * 1000;
